import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { QUERY_KEYS } from '../../queryKeys';
import { vessel } from '../Vessel';

export const UploadVesselManifest = () =>
  useMutation({
    mutationFn: vessel.postVesselManifest,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.vesselManifest] }),
  });
